export default "__VITE_ASSET__CuQkj504__"